// إحصائيات
export default function Stats() {
  const stats = [
    {
      id: 1,
      number: "20+",
      label: "عامًا من الخبرة",
    },
    {
      id: 2,
      number: "100+",
      label: "عميل وشريك",
    },
    {
      id: 3,
      number: "15+",
      label: "موقعًا",
    },
    {
      id: 4,
      number: "50K+",
      label: "طن تم التعامل معها",
    },
  ];

  return (
    <>
      <section className="bg-white py-16" dir="rtl">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
          {/* العنوان */}
          <div className="mx-auto mb-12 max-w-2xl text-center">
            <span className="mb-3 block text-sm font-semibold text-green-600">
              خبرة وإنجاز
            </span>

            <h2 className="text-3xl font-bold text-gray-900 md:text-4xl">
              أرقام تعكس خبرتنا
            </h2>

            <p className="mt-4 leading-7 text-gray-600">
              نعمل بخبرة متراكمة ونقدم حلولًا متكاملة في مجال إعادة التدوير
              والاستدامة.
            </p>
          </div>

          {/* الأرقام */}
          <div className="grid grid-cols-2 gap-6 md:grid-cols-4">
            {stats.map((stat) => (
              <div
                key={stat.id}
                className="group rounded-2xl border border-gray-100 bg-gray-50 p-7 text-center transition-all duration-300 hover:-translate-y-1 hover:bg-white hover:shadow-lg"
              >
                <div className="mb-3 text-4xl font-bold text-green-600 md:text-5xl">
                  {stat.number}
                </div>

                <div className="text-sm font-medium text-gray-600 md:text-base">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
